import { render, staticRenderFns } from "./TicketConnectOrder.vue?vue&type=template&id=2be6aab7&scoped=true"
import script from "./TicketConnectOrder.vue?vue&type=script&lang=js"
export * from "./TicketConnectOrder.vue?vue&type=script&lang=js"
import style0 from "./TicketConnectOrder.vue?vue&type=style&index=0&id=2be6aab7&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2be6aab7",
  null
  
)

export default component.exports